import React from 'react';
import { HomeSchedules } from './components/HomeSchedules';

export const Schedules = () => {
  return <HomeSchedules />;
};
